import { navigate } from 'gatsby';

import {
  CHECKOUT_BASKET_CLEAR,
  CHECKOUT_BROWSER_PAYMENT_SELECT,
  CHECKOUT_CARD_SELECT,
  CHECKOUT_ORDER_MADE,
  CHECKOUT_ORDER_SUCCESSFUL,
  CHECKOUT_PAYMENT_TYPE_SELECT,
  CHECKOUT_STORE_SELECT,
  CHECKOUT_TICKET_SET,
  CHECKOUT_TIMESLOT_SELECT
} from './types';

/**
 * Select payment type
 * @param {string} paymentType payment type, card, browser, konbini
 */
export const selectPaymentType = paymentType => ({
  type: CHECKOUT_PAYMENT_TYPE_SELECT,
  paymentType
});

/**
 * Select timeslot
 * @param {Object} timeslotId timeslot
 */
export const selectTimeslot = timeslot => {
  return {
    type: CHECKOUT_TIMESLOT_SELECT,
    timeslot
  };
};

/**
 * Select payment card
 * @param {string} paymentCardId card source
 */
export const selectCard = paymentCardId => ({
  type: CHECKOUT_CARD_SELECT,
  paymentCardId
});

/**
 * Select convenience store to pay at
 * @param {string} store store name
 */
export const selectStore = store => ({
  type: CHECKOUT_STORE_SELECT,
  store
});

/**
 * Select browser payment request as choice of payment
 */
export const selectBrowserPayment = () => ({
  type: CHECKOUT_BROWSER_PAYMENT_SELECT
});

/**
 * Set number of tickets
 */
export const setNumberOfTickets = tickets => ({
  type: CHECKOUT_TICKET_SET,
  tickets
});

/**
 * Order made
 */
export const orderMade = () => ({
  type: CHECKOUT_ORDER_MADE
});

/**
 * Order success
 */
export const orderSuccess = (orderId, order) => ({
  type: CHECKOUT_ORDER_SUCCESSFUL,
  orderId,
  order
});

/**
 * Clear basket
 */
export const clearBasket = () => ({
  type: CHECKOUT_BASKET_CLEAR
});

/**
 * Make order
 * Process payment
 */
export const makeOrder = order => (dispatch, getState, getFirebase) => {
  const state = getState();
  const firebase = getFirebase();
  const bookingId = order.bookingId || '';
  const isContinue = order.isContinue || false;

  navigate(`/checkout/complete/?orderId=loading&gameId=${order.gameId}&bookingId=${bookingId}&isContinue=${isContinue}`);
  firebase.push(`/orders/${state.auth.user.uid}`, order).then(response => {
    dispatch(orderMade());
    navigate(
      `/checkout/complete/?orderId=${response.key}&gameId=${order.gameId}&bookingId=${bookingId}&isContinue=${isContinue}`
    );
  });
};
